import React, { useEffect, useState, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import clsx from "clsx";
import {
  Button,
  Form,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import Switch from "react-switch";

import iconLeftArrow from "../../../assets/images/icon-left-arrow.png";
import iconChat from "../../../assets/images/chat-icon.png";
import Chat from "../../../assets/images/chat.png";
import iconArrowDown from "../../../assets/images/arrow-down.png";

import Canal from "../../../assets/images/canal.png";
import CanalSelected from "../../../assets/images/canal-selected.png";
import Norme from "../../../assets/images/norme.png";
import NormeSelected from "../../../assets/images/norme-selected.png";
import Motif from "../../../assets/images/motif.png";
import MotifSelected from "../../../assets/images/motif-selected.png";
import Autre from "../../../assets/images/autre.png";
import AutreSelected from "../../../assets/images/autre-selected.png";
import Plus from "../../../assets/images/plus-cercle.png";
import PointsDragDrop from "../../../assets/images/points-drag-drop.png";
import ArrowDown from "../../../assets/images/arrow-down-.png";
import ArrowUpSelected from "../../../assets/images/arrow-up-selected.png";
import PenSelected from "../../../assets/images/selected-pen.png";
import AttributsIcon from "../../../assets/images/IconeAttrb.png";
import CheckCerclePrimary from "../../../assets/images/check-circle-primary.png";
import Trash from "../../../assets/images/trash.png";

import { useDispatch, useSelector } from "react-redux";

import { createGrille, getOneGrilles } from "../../../redux/actions/grille";
import { getAttributsBYPerimetre } from "../../../redux/actions/attribut";
import { addAttributRow, clearAttributRow } from "../../../redux/actions/createGridAttribut";
import grilleService from "../../../services/grille.service";
import ListeAttributes  from "../AddGrille/ListeAttributs/ListeAttributs";


import "./addGrille.css";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Critere from "./critere";
import Alert from "../../../components/Alert/Alert";

const initialCriteria = [];

const staticCriteres = [
  {
    id: "acceuil",
    name: "acceuil",
  },
];

const DuplicateGrid = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const initialGrids = {
    idGrid: 1,
    name: "",
    description: "",
    status: true,
    userId: user?.id,
    CriteriaGroup: [],
  };
  const history = useHistory();
  const dispatch = useDispatch();

  const { message, status } = useSelector((state) => state.message);
  const { datagrille } = useSelector((state) => state.grille);
  const { attributesRow } = useSelector((state) => state.createGridAttribut);


  //const [clickedAttributes, setClickedAttributes] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selectedGrille, setSelectedGrille] = useState("");
  const [selectedGroupesCritere, setSelectedGroupesCritere] = useState({});
  const [clickedAttributes, setClickedAttributes] = useState([]);

  const [display, setDisplay] = useState("none");

  const [isCanal, setIsCanal] = useState(false);
  const [isNorme, setIsNorme] = useState(false);
  const [isMotif, setIsMotif] = useState(false);
  const [isAutre, setIsAutre] = useState(false);

  const [openGroupeCritere, setOpenGroupeCritere] = useState(false);
  const [groupeCritereNameEdit, setGroupeCritereNameEdit] = useState(false);
  const [selectedEditGroupeCritere, setSelectedEditGroupeCritere] = useState(
    {}
  );

  const [isOpenComment, setIsOpenComment] = useState(false);
  const [showSlide , setShowSlide] = useState(false);


  const [groupeCritereName, setGroupeCritereName] = useState("Relationnel");
  const [selectedGridName, setSelectedGridName] = useState(true);

  // ****************
  const [grilles, setGrilles] = useState(null);
  const [groupeCritere, setGroupeCritere] = useState(null);
  const [criteres, setCriteres] = useState(initialCriteria);
  const [Gridattributs , setGridAttributs] = useState();
  const [loading, setLoading] = useState(true);

  let val = window.location.search;
  let GridIdVal = val.substring(val.indexOf("=") + 1);

  const fetchDataGrille = async () => {
    setLoading(true);
    await dispatch(getOneGrilles(GridIdVal));
    setLoading(false);
    setGrilles(datagrille);
  };

  useEffect(()=>{
    let data = {
      perimetre: "QM",
    };
   dispatch(getAttributsBYPerimetre(data));
  },[])

  const findAttrbValues = (arr,id, ValeurAttributs) =>{
    let newArr = [];

   const valeur =  ValeurAttributs?.map((valeur)=>{
    if(arr?.includes(valeur.id)){
     return newArr.push({
        attributId: id,
        label: valeur.name,
        value: valeur.id,
        status : valeur.status
      });
    }
    });

    return newArr;
  }
  const getOneGrille = async () => {
    try {
  
      const response = await grilleService.oneGrille(GridIdVal);
  
      const grid = {
        AttributesGrids: response.data?.grid?.AttributesGrids,
        CriteriaGroup: response.data?.grid?.CriteriaGroup,
        TenantId: response.data?.grid?.TenantId,
        createdAt: response.data?.grid?.createdAt,
        description: response.data?.grid?.description,
        gridAttributes: response.data?.grid?.gridAttributes,
        id: response?.data?.grid?.id,
        name: response.data?.grid?.name + " dupliqué ",
        status: response.data?.grid?.status,
        updatedAt: response.data?.grid?.updatedAt,
        userId: response.data?.grid?.userId,
      };
  
      setGrilles(grid);
      setGroupeCritere(response.data?.grid?.CriteriaGroup);
  
      let Tab = [];
      let index = 0;
      dispatch(clearAttributRow());
  
      response.data?.Attributs?.forEach((item) => {
        item?.AttributValues?.forEach((value) => Tab.push(value.id));
      });
  
      response.data?.Attributs?.forEach((item) => {
        let valuesAttribut = findAttrbValues(Tab, item?.Attribut?.id, item?.Attribut?.ValeurAttribut);
  
        if (item?.Attribut?.status) {
          dispatch(
            addAttributRow({
              attributesIndex: index,
              attribut: item?.Attribut?.name,
              values: valuesAttribut,
              attributId: item?.Attribut?.id,
            })
          );
          index++;
        }
      });
    } catch (error) {
      console.error("Error fetching grille:", error);
    }
  };
  
  useEffect(() => {
    const fetchData = async () => {
      await getOneGrille();
    };
  
    fetchData();
  }, [GridIdVal]);
  const onDisplay = (display) => {
    setDisplay(display);
  };

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(groupeCritere);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setGroupeCritere(items);
  }

  function handleOnDragEndCritere(result) {
    if (!result.destination) return;

    const items = Array.from(criteres);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setCriteres(items);
  }

  // add groupe critere
  const handeladdGroupeCriteres = () => {
    const items = Array.from(groupeCritere);
    const staticGrilles = {
      id:
        groupeCritere.length === 0
          ? 1
          : groupeCritere[groupeCritere.length - 1].id + 1,
      name: "Groupe de critere |",
      description: "",
      Criteria: [],
    };

    items.push(staticGrilles);
    setGroupeCritere(items);
    setGrilles({
      ...grilles,
      CriteriaGroup: items,
    });
  };

  //supprimer groupe critere
  const handelDeleteGroupeGrilles = (id) => {
    const item = groupeCritere.slice(0, id);
    const item2 = groupeCritere.slice(id + 1);
    var items3 = item.concat(item2);
    setGroupeCritere(items3);
    setGroupeCritere(items3);

    setGrilles({
      ...grilles,
      CriteriaGroup: items3,
    });
  };

  //ajouter Critere
  const handeladdCriters = (id) => {
    const items = [];
    const statcitgrille = {
      id:
        groupeCritere.filter((e) => e.id === id)[0]?.Criteria.length === 0
          ? 1
          : groupeCritere.filter((e) => e.id === id)[0]?.Criteria[
              groupeCritere.filter((e) => e.id === id)[0]?.Criteria.length - 1
            ]?.id + 1,
      name: "",
      description: "",
      coefficient: 1,
      impact: true,
      CriteriaValue: [
        {
          id: 1,
          name: "",
          description: "",
          color: " rgb(88,0,226)",
          backGroundColor: "rgba(88,0,226, 0.1)",
        },
        {
          id: 2,
          name: "",
          description: "",
          color: "rgb(88,0,226)",
          backGroundColor: "rgba(88,0,226, 0.1)",
        },
      ],
      CriteriaOption: [],
    };

    items.push(statcitgrille);
    setCriteres(items);
    groupeCritere.filter((e) => e.id === id)[0].Criteria.push(items[0]);
  };

  //supprimer  critere
  const handelDeleteCriters = (idCriteriaGroup, idCriteria) => {
    groupeCritere.filter((e) => e.id === idCriteriaGroup)[0].Criteria =
      groupeCritere
        .filter((e) => e.id === idCriteriaGroup)[0]
        .Criteria.filter((e) => e.id !== idCriteria);
    setGrilles({
      ...grilles,
      CriteriaGroup: groupeCritere,
    });
  };

  //supprimer valeur de critere
  const handelDeleteCriteriaValue = (
    idCriteriaGroup,
    idCriteria,
    idCriteriaValue
  ) => {
    groupeCritere
      .filter((e) => e.id === idCriteriaGroup)[0]
      .Criteria.filter((e) => e.id === idCriteria)[0].CriteriaValue =
      groupeCritere
        ?.filter((e) => e.id === idCriteriaGroup)[0]
        ?.Criteria.filter((e) => e.id === idCriteria)[0]
        ?.CriteriaValue.filter((e) => e.id !== idCriteriaValue);
    setGrilles({
      ...grilles,
      CriteriaGroup: groupeCritere,
    });

    setGroupeCritere(groupeCritere);

  };

  let itemsT = [];
  const handelChangeCriteriaValue = (
    data,
    idGroupeCritere,
    idCritere,
    idCriteriaValue
  ) => {
    itemsT.push(data);
    let uniqueItem = [...new Set(itemsT)];
    let uniqueGroupeCritere = [
      ...new Set(
        groupeCritere
          .filter((e) => e.id === idGroupeCritere)[0]
          .Criteria.filter((e) => e.id === idCritere)[0].CriteriaValue
      ),
    ];
    groupeCritere
      .filter((e) => e.id === idGroupeCritere)[0]
      .Criteria.filter((e) => e.id === idCritere)[0].CriteriaValue =
      uniqueGroupeCritere;
    groupeCritere
      .filter((e) => e.id === idGroupeCritere)[0]
      .Criteria.filter((e) => e.id === idCritere)[0]
      .CriteriaValue.push(uniqueItem[0]);

    uniqueGroupeCritere = [
      ...new Set(
        groupeCritere
          .filter((e) => e.id === idGroupeCritere)[0]
          .Criteria.filter((e) => e.id === idCritere)[0].CriteriaValue
      ),
    ];
    groupeCritere
      .filter((e) => e.id === idGroupeCritere)[0]
      .Criteria.filter((e) => e.id === idCritere)[0].CriteriaValue =
      uniqueGroupeCritere;
    setGrilles({
      ...grilles,
      CriteriaGroup: groupeCritere,
    });
  };

  const handelChangeValueColor = (
    idGroupeCritere,
    idCritere,
    idCriteriaValue,
    colorCriteriaValue
  ) => {
    if (
      grilles.CriteriaGroup.filter((e) => e.id === idGroupeCritere)[0]
        .Criteria.filter((e) => e.id === idCritere)[0]
        .CriteriaValue.filter((e) => e.id === idCriteriaValue)[0]
    ) {
      grilles.CriteriaGroup.filter((e) => e.id === idGroupeCritere)[0]
        .Criteria.filter((e) => e.id === idCritere)[0]
        .CriteriaValue.filter((e) => e.id === idCriteriaValue)[0].color =
        colorCriteriaValue;
      setGrilles({
        ...grilles,
        CriteriaGroup: [...grilles.CriteriaGroup],
      });
    }
  };

  const handelChangeValueDescription = (
    data,
    idGroupeCritere,
    idCritere,
    idCriteriaValue
  ) => {
    if (
      grilles.CriteriaGroup.filter((e) => e.id === idGroupeCritere)[0]
        .Criteria.filter((e) => e.id === idCritere)[0]
        .CriteriaValue.filter((e) => e.id === idCriteriaValue)[0]
    ) {
      grilles.CriteriaGroup.filter((e) => e.id === idGroupeCritere)[0]
        .Criteria.filter((e) => e.id === idCritere)[0]
        .CriteriaValue.filter((e) => e.id === idCriteriaValue)[0].description =
        data;
      setGrilles({
        ...grilles,
        CriteriaGroup: groupeCritere,
      });
    }
  };

  const handelChangeCriteriaOption = (data, idGroupeCritere, idCritere) => {
    groupeCritere
      .filter((e) => e.id === idGroupeCritere)[0]
      .Criteria.filter((e) => e.id === idCritere)[0].CriteriaOption =
      groupeCritere
        .filter((e) => e.id === idGroupeCritere)[0]
        .Criteria.filter((e) => e.id === idCritere)[0]
        .CriteriaOption.filter((e) => e.type !== "NEUTRE");
    if (data.type === "NEUTRE") {
      groupeCritere
        .filter((e) => e.id === idGroupeCritere)[0]
        .Criteria.filter((e) => e.id === idCritere)[0].CriteriaOption = [data];
    } else {
      groupeCritere
        .filter((e) => e.id === idGroupeCritere)[0]
        .Criteria.filter((e) => e.id === idCritere)[0]
        .CriteriaOption.push(data);
    }
    setGrilles({
      ...grilles,
      CriteriaGroup: [...grilles.CriteriaGroup],
    });
  };

  const handelChangeCriteriaOptionName = (
    data,
    idGroupeCritere,
    idCritere,
    idCriteriaOption
  ) => {
    groupeCritere
      .filter((e) => e.id === idGroupeCritere)[0]
      .Criteria.filter((e) => e.id === idCritere)[0]
      .CriteriaOption.filter((e) => e.id === idCriteriaOption)[0].name = data;
    setGrilles({
      ...grilles,
      CriteriaGroup: groupeCritere,
    });
  };

  const handelChangeCriteriaOptionScore = (
    data,
    idGroupeCritere,
    idCritere,
    idCriteriaOption
  ) => {
    groupeCritere
      .filter((e) => e.id === idGroupeCritere)[0]
      .Criteria.filter((e) => e.id === idCritere)[0]
      .CriteriaOption.filter((e) => e.id === idCriteriaOption)[0].score = data;
    setGrilles({
      ...grilles,
      CriteriaGroup: groupeCritere,
    });

  };

  // open Groupe de critere
  const handelOpenCriteriaGroupe = (id) => {
    setOpenGroupeCritere(!openGroupeCritere);
    setSelectedGroupesCritere(id);
    selectedGroupesCritere[id] = !openGroupeCritere;
    setSelectedGroupesCritere({ ...selectedGroupesCritere });
  };

  const handelchangeNomNouvelleGrille = (e) => {
    setGrilles({ ...grilles, name: e.target.value });
  };

  const handelchangeDescriptionNouvelleGrille = (e) => {
    setGrilles({ ...grilles, description: e.target.value });

    if (e.key === "Enter") {
      setIsOpenComment(!isOpenComment);
    }
  };

  const handelchangeCritereGroupeName = (e, id) => {
    grilles.CriteriaGroup.filter((e) => e.id === id)[0].name = e.target.value;
    setGrilles({
      ...grilles,
      CriteriaGroup: [...grilles.CriteriaGroup],
    });

    // grilles.CriteriaGroup[id].name = e.target.value;

    // if (e.key === "Enter") {
    //   selectededitgc[id] = false;
    //   setSelectededitgc({ ...selectededitgc });

    // }
  };

  const handelChangeCriteriaName = (data, idGroupCriteria, idCriteria) => {
    grilles.CriteriaGroup.filter(
      (e) => e.id === idGroupCriteria
    )[0].Criteria.filter((e) => e.id === idCriteria)[0].name = data;
    setGrilles({
      ...grilles,
      CriteriaGroup: [...grilles.CriteriaGroup],
    });
  };

  const handelChangeCriteriaCoefficient = (
    data,
    idGroupCriteria,
    idCriteria
  ) => {
    grilles.CriteriaGroup.filter(
      (e) => e.id === idGroupCriteria
    )[0].Criteria.filter((e) => e.id === idCriteria)[0].coefficient =
      parseInt(data);
    setGrilles({
      ...grilles,
      CriteriaGroup: [...grilles.CriteriaGroup],
    });
  };

  const handelchangeDescriptionCritere = (
    data,
    idGroupCriteria,
    idCriteria
  ) => {
    grilles.CriteriaGroup.filter(
      (e) => e.id === idGroupCriteria
    )[0].Criteria.filter((e) => e.id === idCriteria)[0].description = data;
    setGrilles({
      ...grilles,
      CriteriaGroup: [...grilles.CriteriaGroup],
    });
  };

  const handelchangeCritereImpactant = (data, idGroupCriteria, idCriteria) => {
    grilles.CriteriaGroup.filter(
      (e) => e.id === idGroupCriteria
    )[0].Criteria.filter((e) => e.id === idCriteria)[0].impact = data;
    setGrilles({
      ...grilles,
      CriteriaGroup: [...grilles.CriteriaGroup],
    });
  };

  const structureArry = (arr) => {
    let obj = {};
    arr.forEach((item) => {
      var attributId = item.attributId;
      if (!obj[attributId]) {
        obj[attributId] = [item.value];
      } else {
        obj[attributId].push(item.value);
      }
    });
    return obj;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(clearAttributRow());

    // //VALIDATE
    // var errors = [];
    // //firstname
    // if (value.name === "") {
    //   errors.push("name");
    // }

    // if (
    //   value.CriteriaGroup.map((e) => e.name)[0] === "Critere |" &&
    //   value.name !== ""
    // ) {
    //   errors.push("namegroupecritria");
    // }
    // if (value.CriteriaGroup.map((e) => e.Criteria).length !== 0) {
    //   if (
    //     value.CriteriaGroup.map((e) => e.Criteria.map((e) => e.name))[0][0] ===
    //       "" &&
    //     value.CriteriaGroup.map((e) => e.name)[0] !== "Critere |"
    //   ) {
    //     errors.push("namecritria");

    //   }
    // }

    // setFormErrors(errors);

    // delete IDs
    delete grilles.id;
    delete grilles.createdBy;
    delete grilles.createdAt;
    delete grilles.updatedAt;

    grilles?.AttributesGrids?.map((e)=> delete e.id);
    grilles?.AttributesGrids?.map((e)=> delete e.ValAttributsIds);
    grilles?.AttributesGrids?.map((e)=> delete e.attributId);
    grilles?.AttributesGrids?.map((e)=> delete e.gridId);
    grilles?.AttributesGrids?.map((e)=> delete e.createdAt);
    grilles?.AttributesGrids?.map((e)=> delete e.updatedAt);

    grilles?.CriteriaGroup?.map((e) => delete e.id);
    grilles?.CriteriaGroup?.map((e) => delete e.GridId);
    grilles?.CriteriaGroup?.map((e) => delete e.gridId);
    grilles?.CriteriaGroup?.map((e) => delete e.createdAt);
    grilles?.CriteriaGroup?.map((e) => delete e.updatedAt);
    grilles?.CriteriaGroup?.map((e) => e.Criteria.map((e) => delete e.id));
    grilles?.CriteriaGroup?.map((e) =>
      e?.Criteria?.map((e) => delete e.CriteriaGroupId)
    );
    grilles?.CriteriaGroup?.map((e) =>
      e?.Criteria?.map((e) => delete e.criteriaGroupId)
    );
    grilles?.CriteriaGroup?.map((e) => e?.Criteria?.map((e) => delete e.createdAt));
    grilles?.CriteriaGroup?.map((e) => e?.Criteria?.map((e) => delete e.updatedAt));
    grilles?.CriteriaGroup?.map((e) =>
      e?.Criteria?.map((e) => delete e?.CriteriaValue?.map((e) => delete e.id))
    );
    grilles?.CriteriaGroup?.map((e) =>
      e?.Criteria?.map(
        (e) => delete e.CriteriaValue?.map((e) => delete e.CriterionId)
      )
    );
    grilles?.CriteriaGroup?.map((e) =>
      e.Criteria.map(
        (e) => delete e?.CriteriaValue?.map((e) => delete e.createdAt)
      )
    );
    grilles?.CriteriaGroup?.map((e) =>
      e.Criteria.map(
        (e) => delete e?.CriteriaValue?.map((e) => delete e.updatedAt)
      )
    );
    grilles?.CriteriaGroup?.map((e) =>
      e.Criteria.map((e) => delete e.CriteriaOption.map((e) => delete e.id))
    );

    // grilles['attributes'] = clickedAttributes;
    let newArry = [];
    newArry = attributesRow?.map((item) => item.values);
    const mergeArray = newArry?.flat(1);
    let resultStructre = structureArry(mergeArray);
    let finalResult = [];
    for (let key in resultStructre) {
      finalResult.push({
        attributId: key,
        valuesId: resultStructre[key],
      });
    }
    grilles.attributesListe = finalResult;
    console.log('------------------ dupgrid result===',grilles)
    
    dispatch(createGrille(grilles))
      .then(() => {
        console.log('redirection success!!')
        setDisplay("block");
        setTimeout(() => {
          history.push("/quality-monitoring?id=2");
        }, 2000);
      })
      .catch(() => {
        setDisplay("block");
      });
  };

  const popover = (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className={"form-control"}
        as="textarea"
        rows={3}
        placeholder={grilles?.description}
        defaultValue={grilles?.description}
        onChange={handelchangeDescriptionNouvelleGrille}
      />
      <div className="buttons-of-textarea-comment">
        <span
          style={{ color: "#B7B7B7", cursor: "pointer" }}
          onClick={() => {
            setIsOpenComment(true);
          }}
        >
          Annuler
        </span>
        <span
          style={{ color: "#5800e2", cursor: "pointer" }}
          onClick={() => {
            setIsOpenComment(true);
          }}
        >
          Ajouter
        </span>
      </div>
    </Tooltip>
  );

  const popovergc = (id) => (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className={"form-control"}
        as="textarea"
        rows={3}
        placeholder={""}
        defaultValue={""}
      />
    </Tooltip>
  );

  const popoverAttributes = (
    <Tooltip
      id="tooltip-bottom-action"
      className="tooltip-attributes"
      style={{ opacity: 1 }}
    >
      <div onClick={() => setIsCanal(!isCanal)}>
        {isCanal ? (
          <img alt="" src={CanalSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Canal} width={45} height={45} />
        )}
      </div>
      <div onClick={() => setIsNorme(!isNorme)}>
        {isNorme ? (
          <img alt="" src={NormeSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Norme} width={45} height={45} />
        )}
      </div>
      <div onClick={() => setIsMotif(!isMotif)}>
        {isMotif ? (
          <img alt="" src={MotifSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Motif} width={45} height={45} />
        )}
      </div>
      <div onClick={() => setIsAutre(!isAutre)}>
        {isAutre ? (
          <img alt="" src={AutreSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Autre} width={45} height={45} />
        )}
      </div>
    </Tooltip>
  );
  return grilles === null ||
    grilles === undefined ||
    groupeCritere === null ||
    groupeCritere === undefined ? (
    <div>Loading</div>
  ) : (
    <>
      <div id="nouvelle-eval-body">
        <div id="nouvelle-eval-bar">
          <div className="div-bar">
            <div
              onClick={() => {
                dispatch(clearAttributRow());
                history.goBack();
              }}
              className="container-icon-arraw-left container-icon-arraw-left-add-grille"
            >
              <img src={iconLeftArrow} width="20" height="20" />
            </div>

          {selectedGridName ? (
              <Form.Control
                className="input-nouvelle-grille"
                placeholder="Nouvelle Grille"
                onChange={handelchangeNomNouvelleGrille}
                defaultValue={grilles?.name}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setSelectedGridName(!selectedGridName);
                  }
                }}
              />
            ) : (
              <span
                onClick={() => {
                  setSelectedGridName(!selectedGridName);
                }}
              >
                {grilles?.name}
              </span>
            )}

            {isOpenComment ? (
              <div
                onClick={() => {
                  setIsOpenComment(false);
                }}
              >
                <img
                  className="img-chat-position-add-grille"
                  width={25}
                  src={iconChat}
                />
              </div>
            ) : (
              <OverlayTrigger
                trigger="click"
                rootClose
                placement="bottom-end"
                overlay={popover}
              >
                <img
                  className="img-chat-position-add-grille"
                  width={25}
                  src={iconChat}
                  onClick={() => {
                    setIsOpenComment(false);
                  }}
                />
              </OverlayTrigger>
            )}
          </div>
          <div className="div-bar">
            {/* <OverlayTrigger
              trigger="click"
              placement="bottom-end"
              overlay={popoverAttributes}
            >
              <div
                onClick={() => setClickedAttributes(!clickedAttributes)}
                className={clsx("container-input-attributes", {
                  "container-input-attributes-selected": clickedAttributes,
                })}
              >
                <span style={{ fontSize: "13px", marginRight: "5px" }}>
                  Attributes
                </span>
                <img src={iconArrowDown} alt="Logo" height="6" />
              </div>
            </OverlayTrigger> */}
      
            <OverlayTrigger
              key="bottom"
              placement="bottom"
              overlay={
                !checked ? (
                  <Tooltip data-color="#5800e2" id={`tooltip-bottom`}>
                  <span> Grille Activée </span>
                </Tooltip>
                ) : (
                  <Tooltip data-color="#E30707" id={`tooltip-bottom`}>
                    <span> Grille désactivée </span>
                  </Tooltip>
                )
            }
            >
              <div>
                <Switch
                  onChange={() => {setChecked(!checked); setGrilles({ ...grilles, status: checked });} }
                  checked={checked}
                  className={clsx(
                    { "activate-switch-btn": checked },
                    { "deactivate-switch-btn": !checked }
                  )}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  onColor="#5800e2"
                  height={20}
                  width={38}
                />
              </div>
            </OverlayTrigger>
            <div>
              <img  
                    className="img-chat-position-add-grille"
                    src={AttributsIcon}
                    style={{ cursor: "pointer" , width :45}}
                    onClick={() => {
                     // console.log('slide show=',showSlide)
                      setShowSlide(!showSlide);
                    }}
                    /> 
            </div>
          </div>
        </div>
        <div
          className="container-add-groupe-critere"
          onClick={handeladdGroupeCriteres}
        >
          <img src={Plus} alt="Logo" height={25} />
          <span className="add-grid_btn-title">
            {" "}
            Ajouter un groupe de Critère
          </span>
        </div>

        <div
          id="nouvelle-eval-under-bar"
          className="add-grille-body"
          style={{ overflowY: "scroll" }}
        >
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="groupeCriteres">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{ padding: "2px 20px", width: "100%" }}
                >
                  {groupeCritere.map((val, indexG) => {
                    return (
                      <Draggable
                        key={indexG}
                        draggableId={String(indexG)}
                        index={indexG}
                      >
                        {(provided) => (
                          <div className="row margin-0">
                            <div
                              className="container-groupe-critere"
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div
                                className="row"
                                style={{ height: "100%", margin: 0 }}
                              >
                                <div className="container-drag-drop">
                                  <img src={PointsDragDrop} />
                                </div>
                                <div className="groupe-critere-name">
                                  {selectedEditGroupeCritere[indexG] ? (
                                    <div className="field">
                                      <Form.Control
                                        type="text"
                                        placeholder={`${val?.name}`}
                                        value={val?.name}
                                        className="field__input"
                                        onChange={(e) =>
                                          handelchangeCritereGroupeName(
                                            e,
                                            val?.id
                                          )
                                        }
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            selectedEditGroupeCritere[
                                              indexG
                                            ] = false;
                                            setSelectedEditGroupeCritere({
                                              ...selectedEditGroupeCritere,
                                            });
                                          }
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <span
                                      style={{
                                        fontWeight: 500,
                                        fontFamily: "Gilroy-semiBold",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={() => {
                                        selectedEditGroupeCritere[
                                          indexG
                                        ] = true;
                                        setSelectedEditGroupeCritere({
                                          ...selectedEditGroupeCritere,
                                        });
                                      }}
                                    >
                                      {val?.name}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="icons-groupe-critere">
                                {selectedEditGroupeCritere[indexG] ? (
                                  <div
                                    className="container-icons-groupe-critere"
                                    onClick={() => {
                                      selectedEditGroupeCritere[indexG] = false;
                                      setSelectedEditGroupeCritere({
                                        ...selectedEditGroupeCritere,
                                      });
                                    }}
                                  >
                                    <img src={CheckCerclePrimary} height={15} />
                                  </div>
                                ) : (
                                  <div
                                    className="container-icons-groupe-critere"
                                    onClick={() => {
                                      selectedEditGroupeCritere[indexG] = true;
                                      setSelectedEditGroupeCritere({
                                        ...selectedEditGroupeCritere,
                                      });
                                    }}
                                  >
                                    <img src={PenSelected} height={15} />
                                  </div>
                                )}

                                {isOpenComment ? (
                                  <div className="container-icons-groupe-critere">
                                    <img
                                      className="img-chat-position-groupe-critere"
                                      width={15}
                                      src={iconChat}
                                      onClick={() => {
                                        setIsOpenComment(false);
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div className="container-icons-groupe-critere">
                                    <OverlayTrigger
                                      trigger="click"
                                      rootClose
                                      placement="bottom-end"
                                      overlay={popovergc(indexG)}
                                    >
                                      <img
                                        className="img-chat-position-add-grille"
                                        width={15}
                                        src={Chat}
                                        onClick={() => {
                                          setIsOpenComment(false);
                                        }}
                                      />
                                    </OverlayTrigger>
                                  </div>
                                )}

                                <div
                                  className="container-icons-groupe-critere"
                                  onClick={() =>
                                    handelDeleteGroupeGrilles(indexG)
                                  }
                                >
                                  <img width={15} src={Trash} />
                                </div>

                                <div
                                  className={clsx(
                                    {
                                      "container-icons-groupe-critere":
                                        openGroupeCritere,
                                    },
                                    {
                                      "container-icons-groupe-critere-selected":
                                        !openGroupeCritere,
                                    }
                                  )}
                                  onClick={() => {
                                    handelOpenCriteriaGroupe(indexG);
                                  }}
                                >
                                  {selectedGroupesCritere[indexG] ? (
                                    <img src={ArrowDown} />
                                  ) : (
                                    <img src={ArrowUpSelected} />
                                  )}
                                </div>
                              </div>
                            </div>

                            {selectedGroupesCritere[indexG] ? (
                              <>
                                <DragDropContext
                                  onDragEnd={handleOnDragEndCritere}
                                >
                                  <Droppable droppableId="criters">
                                    {(provided) => (
                                      <div
                                        className="characters"
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={{ width: "98%" }}
                                      >
                                        {groupeCritere[indexG]?.Criteria.map(
                                          (criteriaVal, index) => {
                                            return (
                                              <Draggable
                                                key={criteriaVal?.id}
                                                draggableId={String(
                                                  criteriaVal?.id
                                                )}
                                                index={index}
                                              >
                                                {(provided) => (
                                                  <div
                                                    style={{ width: "100%" }}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                  >
                                                    <Critere
                                                      key={index}
                                                      groupeCritere={
                                                        groupeCritere
                                                      }
                                                      criteres={val?.Criteria}
                                                      idGroupCriteria={val?.id}
                                                      idCriteria={
                                                        criteriaVal?.id
                                                      }
                                                      handelDeleteCriters={
                                                        handelDeleteCriters
                                                      }
                                                      handelChangeCriteriaValue={
                                                        handelChangeCriteriaValue
                                                      }
                                                      handelChangeValueColor={
                                                        handelChangeValueColor
                                                      }
                                                      handelChangeValueDescription={
                                                        handelChangeValueDescription
                                                      }
                                                      handelChangeCriteriaName={
                                                        handelChangeCriteriaName
                                                      }
                                                      handelDeleteCriteriaValue={
                                                        handelDeleteCriteriaValue
                                                      }
                                                      handelChangeCriteriaOption={
                                                        handelChangeCriteriaOption
                                                      }
                                                      handelChangeCriteriaOptionName={
                                                        handelChangeCriteriaOptionName
                                                      }
                                                      handelChangeCriteriaOptionScore={
                                                        handelChangeCriteriaOptionScore
                                                      }
                                                      handelchangeCritereImpactant={
                                                        handelchangeCritereImpactant
                                                      }
                                                      handelchangeDescriptionCritere={
                                                        handelchangeDescriptionCritere
                                                      }
                                                      handelChangeCriteriaCoefficient={
                                                        handelChangeCriteriaCoefficient
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </Draggable>
                                            );
                                          }
                                        )}
                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                                <div
                                  className="container-add-critere"
                                  onClick={() => {
                                    handeladdCriters(val?.id);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 40 40"
                                  >
                                    <g
                                      id="Groupe_18605"
                                      data-name="Groupe 18605"
                                      transform="translate(-696 -140)"
                                    >
                                      <rect
                                        id="Rectangle_32"
                                        data-name="Rectangle 32"
                                        width="40"
                                        height="40"
                                        rx="20"
                                        transform="translate(696 140)"
                                        fill="#ccb2f6"
                                      />
                                      <path
                                        id="plus.2"
                                        d="M15.972,70.944H9.722v-6.25A.694.694,0,0,0,9.028,64H7.639a.694.694,0,0,0-.694.694v6.25H.694A.694.694,0,0,0,0,71.639v1.389a.694.694,0,0,0,.694.694h6.25v6.25a.694.694,0,0,0,.694.694H9.028a.694.694,0,0,0,.694-.694v-6.25h6.25a.694.694,0,0,0,.694-.694V71.639A.694.694,0,0,0,15.972,70.944Z"
                                        transform="translate(708 88)"
                                        fill="#fff"
                                      />
                                    </g>
                                  </svg>
                                  <span> Ajouter un Critere</span>
                                </div>
                              </>
                            ) : null}
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div
            style={{
              zIndex: "1",
              position: "absolute",
              right: "3vw",
              bottom: "-23%",
              display:"flex"
            }}
          >
            <Button
              variant="primary"
              className="buttons"
              style={{
                backgroundColor: "white",
                borderColor: "gray",
                color: "gray",
              }}
              onClick={() => {
                dispatch(clearAttributRow());
                history.goBack();
              }}
            >
              Annuler
            </Button>
            <Button
              variant="primary"
              className="buttons"
              style={{
                backgroundColor: "#5800e2",
                marginLeft: "5px",
              }}
              onClick={handleSubmit}
            >
              Enregistrer
            </Button>
          </div>
        </div>
      </div>
      {message && (
        <Alert
          message={message}
          status={status === "error" ? "danger" : "success"}
          style={{ position: "absolute", bottom: 10, zIndex: 10000000 }}
          display={display}
          onDisplay={onDisplay}
        />
      )}
       {showSlide && 
          <ListeAttributes  
          ficheAttribute={showSlide} 
          showFicheAttribute={setShowSlide}
          grid={grilles?.AttributesGrids }
          />
       }
    </>
  );
};

export default DuplicateGrid;
